
import {Component} from 'vue-property-decorator'
import BasePanel from '../base/BasePanel.vue'
import PropertyMaintenanceSystemFormDialog from "@/components/properties/PropertyMaintenanceSystemFormDialog.vue"
import { BasePropertyMaintenanceSystemsComponent } from '../base/BaseMixins'
@Component({components: {BasePanel, PropertyMaintenanceSystemFormDialog}})
export default class PropertyMaintenanceSystemInfo extends BasePropertyMaintenanceSystemsComponent {
  editDialog : boolean = false
}
